import AndContainer from 'components/common/AndContainer';
import { Arrangement } from 'types/arrangement';
import CaptionText from 'components/common/CaptionText';
import { Container } from 'components/credits/credit-details/SubjectsSection/components';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { Fragment } from 'react';
import { MiniLogo } from '../ArticulationDetailsCard/components';
import { Precedent } from 'types/precedent';
import { Spin } from 'antd';
import { Strong } from 'components/common/Strong';
import { interpolate } from 'utils/interpolate';
import useTranslation from 'hooks/use-translation';

type Props =
  | { arrangement: Arrangement; creditType: CreditType.ARTICULATION }
  | { precedent: Precedent; creditType: CreditType.PRECEDENT };

export default function SubjectsSection(props: Props): JSX.Element {
  const { creditType } = props;
  const translation = useTranslation();

  const subjects = creditType === CreditType.ARTICULATION ? props.arrangement.subjects : props.precedent.subjects;

  if (!translation) {
    return <Spin />;
  }

  return (
    <Container flexDirection='column' justifyContent='space-between'>
      <Strong>{translation.details.targetDescription}</Strong>
      <FlexContainer gap={4} flex={1} flexDirection='column'>
        {subjects.map((subject, index, array) => {
          const subjectText = subject.unspecified
            ? subject.name
            : interpolate(translation.subjectFormat, { name: subject.name, code: subject.code });
          return (
            <Fragment key={subject.ID}>
              <span className='target-subject-heading'>{subjectText}</span>
              {index !== array.length - 1 && <AndContainer />}
            </Fragment>
          );
        })}
        <CaptionText className='institution-label'>{translation.institution}</CaptionText>
      </FlexContainer>
      <div>
        <MiniLogo
          src={`./config/icons/${translation.common.icons.logoSmall.src}`}
          alt={translation.common.icons.logoSmall.alt}
        />
      </div>
    </Container>
  );
}
